const sticky_menu_fn = {
  init: function(sticky_menu_id) {
    sticky_menu_id = sticky_menu_id || 'div[id*="sticky-menu"]';
    var sticky_menu = $(sticky_menu_id);
    
    sticky_menu_id = '#'+sticky_menu.attr('id');

    var download_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.22292 1.77954H0.825195C0.618089 1.77954 0.450195 1.94743 0.450195 2.15454V10.95C0.450195 11.1571 0.618089 11.325 0.825195 11.325H9.62065C9.82776 11.325 9.99565 11.1571 9.99565 10.95V6.87045H9.24565V10.575H1.2002V2.52954H5.22292V1.77954Z" fill="black"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5334 0.559786C11.6798 0.706233 11.6798 0.94367 11.5334 1.09012L6.1773 6.44619L5.64697 5.91586L11.003 0.559786C11.1495 0.41334 11.3869 0.41334 11.5334 0.559786Z" fill="black"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.75684 0.449951H11.2682C11.4753 0.449951 11.6432 0.617844 11.6432 0.824951V5.33632H10.8932V1.19995H6.75684V0.449951Z" fill="black"/>
    </svg>`;

    var datas = sticky_menu.data();
    var menu_html = ``;
    if (datas.hasOwnProperty('menu') && datas['menu'] != '') {
      var divider = datas['menu'].indexOf('|') >= 0 ? '|' : ',';
      var menus = datas['menu'].split(divider);
      var anchors = datas['anchor'].split(divider);
      $.each(menus, function (i, menu) {
        var link = anchors[i].trim();
        var is_link = link.indexOf('/') >= 0 || link.indexOf('http') >= 0;
        link = is_link ? link : `#${link}`;

        var icon = is_link ? download_icon : '';
        menu_html += `<a data-track-id="product_details_tab" href="${link}" class="menu-link">${menu.trim()} ${icon}</a>`
      });
    }

    var cta_menu_html = ``;
    if (datas.hasOwnProperty('buttonDropdownMenu') && datas['buttonDropdownMenu'] != '') {
      var divider = datas['buttonDropdownMenu'].indexOf('|') >= 0 ? '|' : ',';
      var menus = datas['buttonDropdownMenu'].split(divider);
      var links = datas['buttonDropdownLink'].split(divider);

      cta_menu_html = `<div class="cta-dropdown-menu">`;
      $.each(menus, function (i, menu) {
        var link = links[i].trim();
        var is_link = link.indexOf('/') >= 0 || link.indexOf('http') >= 0;
        link = is_link ? link : `#${link}`;

        var icon = is_link ? download_icon : '';
        icon = '';
        cta_menu_html += `<a href="${link}" class="menu-link">${menu.trim()} ${icon}</a>`
      });
      cta_menu_html += `</div>`;
    }
    var cta_html = ``;
    // var cta_html = datas.hasOwnProperty('buttonLink') && datas['buttonLink']!='' 
    //   && datas.hasOwnProperty('buttonText') && datas['buttonText']!='' ? `<div class="cta">
    //   <a href="${datas['buttonLink']}" class="btn cta-button">${datas['buttonText']}</a>
    //   ${cta_menu_html}
    // </div>` : '';
    if (datas.hasOwnProperty('buttonText') && datas['buttonText']!='') {
      cta_html += `<div class="cta">`;
      if (cta_menu_html != '') {
        cta_html += `<button type="button" class="btn btn-secondary cta-button cta-button-dropdown">${datas['buttonText']}</button>
          ${cta_menu_html}`;
      } else if (datas.hasOwnProperty('buttonLink') && datas['buttonLink']!='' && datas.hasOwnProperty('buttonText') && datas['buttonText']!='') {
        cta_html += `<a href="${datas['buttonLink']}" class="btn btn-secondary cta-button">${datas['buttonText']}</a>`;
      }
      cta_html += `</div>`;
    }

    var btn_pdp = ctaPdp(false);
    var add_to_cart_html = btn_pdp !== false && datas.hasOwnProperty('buttonPdp') && datas['buttonPdp']!==false ? `<div class="cta cta-pdp"${btn_pdp!= false ? '' : 'style="display: none;"'}>
      <a href="${btn_pdp!= false ? (btn_pdp.attr('href') || '#') : '#'}" class="btn btn-secondary cta-button cta-button-pdp">${btn_pdp!= false ? btn_pdp.text() : ''}</a>
    </div>` : '';
    var html = `<div class="container"><div class="row">
      ${(datas['leftTitle'] != '') ? `<div class="col-auto sticky-left">
        <button type="button" class="menu-button">${datas['leftTitle']}</button>
      </div>` : ``}
      <div class="col-auto sticky-right">
        <div class="menu-bar">
          <div>
            ${menu_html}
          </div>
        </div>
      </div>
      ${(cta_html != '' || add_to_cart_html != '') ? `<div class="col-auto sticky-cta">
        ${cta_html}
        ${add_to_cart_html}
      </div>` : ``}
    </div></div>`;
    sticky_menu.parent().html(html)
      .attr('id', sticky_menu_id.replace('#',''))
      .addClass((sticky_menu.attr('class') || 'sticky-menu-section'));

    var menu_scroll = $(sticky_menu_id).find('.menu-bar');
    var menu_content = $(sticky_menu_id).find('.menu-bar > div');

    $('.menu-link span', menu_content).each(function() {
      var bg = $(this).attr('data-bg');
      if (typeof bg !== 'undefined' && bg != '') {
        $(this).css('--sticky-menu-label-bg', bg);
      }
      var color = $(this).attr('data-color');
      if (typeof color !== 'undefined' && color != '') {
        $(this).css('--sticky-menu-label-color', color);
      }
    });

    if (menu_scroll.outerWidth() <= (menu_content.outerWidth() + 40)) {
      menu_scroll.parent().addClass('scroll-active');
    }

    $(sticky_menu_id).on('click', '.menu-button', function(e) {
      $(sticky_menu_id).toggleClass('active');
      $('#MainContent').toggleClass('page-sticky-menu-section-active');
    });

    $(sticky_menu_id).on('click', '.menu-link, .cta-button', function(e) {
      $(sticky_menu_id).removeClass('active');
      $('#MainContent').removeClass('page-sticky-menu-section-active');

      var link = ($(this).attr('href') || '').trim();
      if (link.indexOf('/') >= 0) {
        return true;
      }

      var anchor = link.replace('#','');
      scrollAnchor(anchor);
      e.preventDefault();
    });

    $(document).on('keyup', function (e) {
      if ((e.keyCode || e.which) === 27) {
        $('.cta-button-dropdown').removeClass('active');
      }
    });
    $(document).on('click', function(e) {
      if ($(e.target).closest('.cta').length === 0) {
        $('.cta-button-dropdown').removeClass('active');
      }
    });
    $(sticky_menu_id).on('click', '.cta-button-dropdown', function(e) {
      $(this).toggleClass('active')
    });

    $(sticky_menu_id).on('click', '.cta-button-pdp', function(e) {
      var btn = ctaPdp();
      
      if (btn === false) {
        e.preventDefault();
        return false;
      }
      
      if (typeof btn.attr('data-fancybox') !== 'undefined') {
        btn.trigger('click');
        window.$fancybox.open({
          src: btn.attr('data-src'), 
        });
      } else {
        btn.trigger('click');
      }
    });

    $('.product-container').on('variantChange', function() {
      setTimeout(function() {
        ctaPdp();
      }, 150);
    });
    function ctaPdp(check_menu = true) {
      var btn = false;
      var btn_atc = $('#AddToCart-product-template:visible');
      var btn_notify_me = $('a[data-src="#notify-me-modal"]:visible');
      if (btn_notify_me.length == 0) {
        btn_notify_me = $('a[data-notify_me_modal="true"]:visible');
      }
      var btn_enquiry = $('.product-enquiry-locator .row > div:first-child a:visible');
      var btn_mykef = $('#mykef-exclusive-button-link:visible');
      if (btn_atc.length == 1) {
        btn = btn_atc;
      } else if (btn_notify_me.length == 1) {
        btn = btn_notify_me;
      } else if (btn_enquiry.length == 1) {
        btn = btn_enquiry;
      } else if (btn_mykef.length == 1) {
        btn = btn_mykef;
      }

      if (check_menu) {
        var btn_pdp = $(sticky_menu_id).find('.cta-button-pdp');
        if (btn_pdp.length == 0) return false;
        btn_pdp.parent().show();

        if (btn === false) {
          btn_pdp.hide();
          return false;
        }

        btn_pdp.show();
        btn_pdp.attr('href', btn.attr('href') || '#');
        btn_pdp.text(btn.text());
        // data-track-id
        if (btn_atc.length == 1) {
          btn_pdp.attr('data-track-id', 'add_to_cart');
        } else if (btn_notify_me.length == 1) {
          btn_pdp.attr('data-track-id', 'notify_me');
        } else if (btn_enquiry.length == 1) {
          btn_pdp.attr('data-track-id', 'product_enquiry');
        } else if (btn_mykef.length == 1) {
          btn_pdp.attr('data-track-id', 'sign_up_link');
        }

        var menu_scroll = $(sticky_menu_id).find('.menu-bar');
        var menu_content = $(sticky_menu_id).find('.menu-bar > div');
        if (menu_scroll.outerWidth() <= (menu_content.outerWidth() + 40)) {
          menu_scroll.parent().addClass('scroll-active');
        }
      }
      return btn;
    }

    $(window).on('load', function() {
      ctaPdp();

      if (window.location.hash) {
        var anchor = window.location.hash.replace('#','');
        scrollAnchor(anchor);
      }
    }).on('scroll', function() {
      sticky_menu_fn.updateScrollSpy(sticky_menu_id, $(this));
    });

    function scrollAnchor(anchor) {
      var el = $('a[name="'+anchor+'"]');
      if (el.length == 0) return;
      var pos = Math.ceil(el.offset().top);

      var h = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height').replace('px', ''));
      if ($(window).width() < 1024 && document.body.classList.contains('scroll-btm')) {
        h = parseInt(getComputedStyle(document.body).getPropertyValue('--header-v3-height').replace('px', ''))
      }
      if ($(window).width() < 1024 && Math.ceil($(window).scrollTop()) > pos) {
        h += parseInt(getComputedStyle(document.body).getPropertyValue('--header-announcement-height').replace('px', ''));
      }
      h += parseInt(getComputedStyle(document.body).getPropertyValue('--sticky-menu-height').replace('px', ''));

      // pos -= Math.ceil($(sticky_menu_id).outerHeight());
      // pos -= Math.ceil(Math.ceil($(window).scrollTop()) > pos ? Math.ceil($('#header').outerHeight()) : 0);
      pos -= h;
      pos -= $(window).width() > 480 ? 40 : 0;
      
      $('body, html').animate({
        scrollTop: pos
      }, 500);
    }
  },
  updateScrollSpy: function(menu_id, _t) {
    menu_id = menu_id || 'div[id*="sticky-menu"]';

    var body = $('body');
    var header = $('#header');
    var currentTop = (_t.scrollTop());
    var elems = $(menu_id+' .menu-link');
    if (elems.length == 0) return;

    var navElem = false;
    elems.each(function(index) {
      var link = $(this).attr('href').trim();
      var is_link = link.indexOf('/') >= 0 || link.indexOf('http') >= 0;
      if (is_link) return;

      var name = link.replace('#', ''),
          _this = $('#MainContent a[name="'+name+'"]');

      if (_this.length == 0) return;

      var has_announcement = $('.shopify-section-header-announcement .swiper-slide').length > 0;

      var elemTop = (
        _this.offset().top 
        - (body.hasClass('scroll-top') ? header.outerHeight()*2 : 0)
        - (body.hasClass('scroll-btm') ? header.outerHeight()*1.5 : 0)
        - ($(window).width() > 480 ? (has_announcement ? 80 : 120) : (has_announcement ? 80 : 40))
      );

      var bottom = elems.get(index+1);
      var elemBottom = (
        elemTop 
        + (typeof bottom !== 'undefined' ? $(bottom).offset().top : $('#MainContent').height())
      );
      
      if ((currentTop >= elemTop && currentTop <= elemBottom)) {
        navElem = $(menu_id+' .menu-link[href="#'+name+'"]');
      } else if ((elemTop == elemBottom && currentTop >= elemBottom)) {
        navElem = $(menu_id+' .menu-link[href="#'+name+'"]');
      }
    });

    if (navElem !== false && ! navElem.hasClass('active')) {
      navElem.addClass('active').siblings().removeClass('active');

      if ($(menu_id).hasClass('sticky-menu-section-v2')) {
        var prevElems = navElem.prevAll('.menu-link'),
            w = 0;
        prevElems.each(function() {
          w += $(this).width() + 24
        });
        $(menu_id+' .menu-bar > div').animate({
          scrollLeft: w,
        });
      }
    } else if (! navElem) {
      $('.menu-link').removeClass('active');
    }
  }
};
sticky_menu_fn.init();